import { getThemeToProvide, getThemeToProvideSync, isSyncThemeSettings, trackTheme } from '../components/ThemeProvider/ThemeProvider.helpers';
import { DEFAULT_SETTINGS, getLocalThemeSettings } from './getLocalThemeSettings';
import devLogger from 'react-utils/devLogger';
export const TRELLIS_THEME_EVENT = 'trellis:theme';
export class ThemeManager {
  constructor() {
    this.themeRequestCounter = 0;
    this.subscribers = new Set();
    this.setThemeObject = theme => {
      this.theme = theme;
      this.subscribers.forEach(callback => callback());
    };
    this.subscribeToWindowEvents = () => {
      window.addEventListener('message', this.handleUpdateEvent);
    };
    this.destroy = () => {
      window.removeEventListener('message', this.handleUpdateEvent);
    };
    this.handleUpdateEvent = event => {
      var _event$data;
      if ((event === null || event === void 0 || (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.type) !== TRELLIS_THEME_EVENT) {
        return;
      }
      const newThemeSettings = getLocalThemeSettings();
      this.handleUpdate(newThemeSettings);
    };
    this.handleUpdate = newThemeSettings => {
      trackTheme(newThemeSettings.themeName, newThemeSettings.themeMode);
      this.themeRequestCounter += 1;
      const currentRequestId = this.themeRequestCounter;
      if (isSyncThemeSettings(newThemeSettings)) {
        const syncTheme = getThemeToProvideSync(newThemeSettings);
        this.setThemeObject(syncTheme);
      } else {
        getThemeToProvide(newThemeSettings).then(theme => {
          if (currentRequestId === this.themeRequestCounter) {
            this.setThemeObject(theme);
          }
        }).catch(error => {
          devLogger.warn({
            message: `Failed to load theme with error: ${error}`,
            key: 'foundations-theming:theme-manager:theme-load-failure'
          });
        });
      }
    };
    this.subscribe = callback => {
      this.subscribers.add(callback);
      return () => {
        this.subscribers.delete(callback);
      };
    };
    this.getTheme = () => {
      return this.theme;
    };
    this.setTheme = themeSettings => {
      const newThemeSettings = Object.assign({}, DEFAULT_SETTINGS, themeSettings);
      this.handleUpdate(newThemeSettings);
    };
    const _themeSettings = getLocalThemeSettings();
    this.theme = getThemeToProvideSync(_themeSettings);
    this.handleUpdate(_themeSettings);
  }
}
export let globalThemeManager;
export function createGlobalThemeManager() {
  if (globalThemeManager) {
    globalThemeManager.destroy();
  }
  globalThemeManager = new ThemeManager();
  globalThemeManager.subscribeToWindowEvents();
}
createGlobalThemeManager();